var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5696 7.17C14.5696 8.5713 13.4335 9.70696 12.0326 9.70696C10.6313 9.70696 9.49522 8.5713 9.49522 7.17C9.49522 5.7687 10.6313 4.63304 12.0326 4.63304C13.4335 4.63304 14.5696 5.7687 14.5696 7.17ZM12.0322 11.9739C9.37913 11.9739 7.22826 9.82304 7.22826 7.17C7.22826 4.51696 9.37913 2.36609 12.0322 2.36609C14.6857 2.36609 16.8365 4.51696 16.8365 7.17C16.8365 9.82304 14.6857 11.9739 12.0322 11.9739ZM12.0326 0C5.38696 0 0 7.13478 0 7.13478C0 7.13478 5.38696 14.34 12.0326 14.34C18.6778 14.34 24.0648 7.13478 24.0648 7.13478C24.0648 7.13478 18.6778 0 12.0326 0Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.2a61f1d5.svg";
export { ForwardRef as ReactComponent };